import { defineMessages } from 'react-intl'

export default defineMessages({
  addToWishlist: {
    id: 'addToWishlist',
    defaultMessage: 'ADD TO WISHLIST',
  },
  removeFromWishlist: {
    id: 'removeFromWishlist',
    defaultMessage: 'REMOVE FROM WISHLIST',
  },
  diveInsuranceDescription: {
    id: 'diveInsuranceDescription',
    defaultMessage: 'We have partnered with DAN - Divers Alert Network - to offer you free dive accident insurance for the duration of your trip (valid for bookings with a value of > USD {price} per person)',
  },
  fullyFlexibleDescription: {
    id: 'fullyFlexibleDescription',
    defaultMessage: 'You can customize the number of dives for each diver during the checkout process. The package price will be adjusted dynamically',
  },
  notFlexibleDives: {
    id: 'notFlexibleDives',
    defaultMessage: 'This is the total number of dives you get for the price you pay and includes, if offered as part of your package, non-standard dives such as night dives and special trips.',
  },
  tooltipMealplanInfo: {
    id: 'tooltipMealplanInfo',
    defaultMessage: 'Click here to find out what`s included in this meal plan.',
  },
  courseTooltip: {
    id: 'courseTooltip',
    defaultMessage: 'Click here to find out what`s included.',
  },
  whatIsMissing: {
    id: 'whatIsMissing',
    defaultMessage: 'What information is missing?',
  },
  whatShouldWeAdd: {
    id: 'whatShouldWeAdd',
    defaultMessage: 'What other info would be helpful?',
  },
  showAvailable: {
    id: 'showAvailable',
    defaultMessage: 'Show available',
  },
  showAll: {
    id: 'showAll',
    defaultMessage: 'Show all',
  },
  next30: {
    id: 'next30',
    defaultMessage: 'Next 30 days',
  },
  topicToSuggest: {
    id: 'topicToSuggest',
    defaultMessage: 'What topic do you want to suggest?',
  },
  search: {
    id: 'search',
    defaultMessage: 'Search',
  }
})
